<template>
  <v-card>
    <v-card-title>
      Partneři
    </v-card-title>
    <v-card-actions>
      <add-partner-dialog @update="createPartner">
        <template #default="{on, attrs}">
          <v-btn outlined
                 small
                 color="primary"
                 v-on="on"
                 class="mx-1"
                 v-bind="attrs">PŘIDAT PARTNERA</v-btn>
        </template>
      </add-partner-dialog>
      <v-btn small color="secondary" :disabled="selectedUser.length === 0" outlined @click="removePartner">ODSTRANIT PARTNERA</v-btn>
    </v-card-actions>
    <v-data-table class="yzz-table"
                  dense
                  :headers="headers"
                  :items="items"
                  :server-items-length="itemsLength"
                  :options.sync="options"
                  :footer-props="footerProps"
                  multi-sort
                  mobile-breakpoint="-1"
                  show-select
                  single-select
                  v-model="selectedUser"
                  @click:row="openUser"
                  item-key="_id"
    >
      <template #item.fullName="{ item }">
        {{ formatFullName(item)}}
      </template>
      <template #item.providers="{item}">
        {{ formatProvidersData(item) }}
      </template>
    </v-data-table>
  </v-card>
</template>

<script>

import {exportCSVFile, generateRequestParams} from '@/helper/global-helper'
import UserBlockDialog from '@/components/app/users/UserBlockDialog'
import AddPartnerDialog from '@/components/app/partners/AddPartnerDialog'
export default {
  components: {
    UserBlockDialog,
    AddPartnerDialog
  },
  name: "UsersTable",
  data() {
    return {
      headers: [
        {text: 'Partner', value: 'fullName', sortable: false},
        {text: 'Adresa', value: 'address', sortable: false},
        {text: 'IČO', value: 'ico', sortable: false},
        {text: 'Telefonní číslo', value: 'phoneNumber', sortable: false},
        {text: 'Email', value: 'email', sortable: false},
        {text: 'Přidružení poskytovatelé', value: 'providers', sortable: false},
      ],
      options: {
        itemsPerPage: 15
      },
      footerProps: {
        itemsPerPageOptions: [15, 25, 50]
      },
      data: null,
      search: null,
      selectedUser: []
    }
  },
  mounted() {
    this.getData()
  },
  computed: {
    itemsLength() {
      if (!this.data) return 0
      return this.data.total
    },
    items() {
      if (!this.data) return []
      return this.data.data
    }
  },
  methods: {
    getData() {
      let params= generateRequestParams(
          this.options.itemsPerPage * (this.options.page - 1),
          this.options.itemsPerPage,
          null,
          this.options.sortDesc[this.options.sortBy.indexOf("createdAt")] ? "asc" : "desc"
      )
      this.axios.get('v1/partners', {
        params
      })
          .then(({data}) => {
            this.data = data
          })
    },
    createPartner(data){
      this.getData()
    },
    removePartner(){
      const userId = this.selectedUser[0]._id
      this.axios.delete(`/v1/partners/${userId}`).then((data)=>{
        this.data.data = this.data.data.filter(item => item._id !== userId)
        this.$store.commit('addAlert', {
          type: 'success',
          message: "Úspěšně"
        })
      })
    },
    openUser({ _id }) {
      this.$router.push('/app/partners/' + _id)
    },
    formatFullName(item) {
      return item?.name
    },
    formatProvidersData(item){
      return item.providers.map(provider => provider.businessName).join('; ')
    },
    exportCsv(){
      exportCSVFile(this.headers, this.items, 'users')
    }
  },
  watch: {
    options: {
      handler() {
        this.getData()
      },
      deep: true,
    }
  }
}
</script>

<style scoped>
.active{
  color: green;
}
.inactive{
  color: red;
}
</style>